import { render, staticRenderFns } from "./Mailehui.vue?vue&type=template&id=28ec341a&scoped=true&"
import script from "./Mailehui.vue?vue&type=script&lang=js&"
export * from "./Mailehui.vue?vue&type=script&lang=js&"
import style0 from "./Mailehui.vue?vue&type=style&index=0&id=28ec341a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec341a",
  null
  
)

export default component.exports